var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcYoutubeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9954 6.00253C17.8038 5.28753 17.2413 4.72336 16.5271 4.53086C15.2221 4.17253 10.0013 4.16669 10.0013 4.16669C10.0013 4.16669 4.78125 4.16086 3.47542 4.50336C2.77542 4.69419 2.19708 5.27086 2.00375 5.98503C1.65958 7.29003 1.65625 9.99669 1.65625 9.99669C1.65625 9.99669 1.65292 12.7167 1.99458 14.0084C2.18625 14.7225 2.74875 15.2867 3.46375 15.4792C4.78208 15.8375 9.98875 15.8434 9.98875 15.8434C9.98875 15.8434 15.2096 15.8492 16.5146 15.5075C17.2279 15.3159 17.7929 14.7525 17.9871 14.0384C18.3321 12.7342 18.3346 10.0284 18.3346 10.0284C18.3346 10.0284 18.3513 7.30753 17.9954 6.00253ZM8.33125 12.5042L8.33542 7.50419L12.6746 10.0084L8.33125 12.5042Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutubeWhite);
export default __webpack_public_path__ + "static/media/ic_youtube_white.03b6531f1d8ca1c989cb434023f43cb0.svg";
export { ForwardRef as ReactComponent };